import { ISyncQueueItem } from "@home-health-notify/models";
import { ROUTES } from "../routes";

export function patientPath(orgId: string, patientId: string): string {
  return `${ROUTES.ORGANIZATIONS}/${orgId}/${ROUTES.CHATS}/${ROUTES.PATIENT}/${patientId}/${ROUTES.MESSAGE}`;
}

export function patientName(item: ISyncQueueItem): string {
  const info = item.payload?.patientInfo;
  const full = info
    ? `${info.firstName ?? ""} ${info.lastName ?? ""}`.trim()
    : "";
  return full || item.payload?.name || "—";
}

export function addressLine(item: ISyncQueueItem): string {
  const address = item.payload?.patientInfo?.address;
  if (!address) return "";
  return [address.placeName, address.city, address.state, address.zipCode]
    .filter(Boolean)
    .join(", ");
}

export function servicesSummary(item: ISyncQueueItem): string {
  return (item.payload?.servicesToPatient ?? []).map(s => s.name).join(", ");
}

export function formatDateTime(epochMs: number): string {
  const date = new Date(epochMs);
  const dateStr = date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const timeStr = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${dateStr} ${timeStr}`;
}

export function matchesSearch(item: ISyncQueueItem, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    patientName(item).toLowerCase().includes(q) ||
    item.emrId.toLowerCase().includes(q)
  );
}
